import { z } from "zod/v4";

import { FindReplaceSchema } from "../../../../../find-replaces";

export const PluginFindReplaceSchema_2023_08_20 = FindReplaceSchema.omit({
  isMinimized: true,
  errors: true,
});
export type PluginFindReplaceType_2023_08_20 = z.infer<
  typeof PluginFindReplaceSchema_2023_08_20
>;
